export const SecretPageKey = "secret";

export const IS_SHOW_SECRET_PAGE = JSON.parse(
	localStorage.getItem(SecretPageKey) || process.env.REACT_APP_IS_SHOW_SECRET_PAGE || "false"
) as boolean;
